import {
  Alert,
  CardActions,
  CardHeader,
  Chip,
  Divider,
  Grid,
  LinearProgress,
  Paper,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AppButton from "../../shares/AppButton";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import BusinessIcon from "@mui/icons-material/Business";
import { DeleteOutline, EditOutlined, InfoOutlined } from "@material-ui/icons";
import { CalendarMonthOutlined, Science } from "@mui/icons-material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import ExperienceForm from "./forms/ExperienceForm";
import { useQuery } from "../../../../hooks/useQuery";
import useConfirm from "../../../../hooks/useConfirm";
import useToast from "../../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../../shares/NotificationBull";
import { CVExperienceService } from "../../../../service/CVExperienceService";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";

export function calculeExperience(date_debut, date_fin) {
  let dateFin =
    date_fin && date_fin !== "0000-00-00" ? new Date(date_fin) : new Date();
  let dateDebut = new Date(date_debut);
  try {
    const differenceInDays = dateFin.getDate() - dateDebut.getDate();
    const differenceInMonths =
      (dateFin.getFullYear() - dateDebut.getFullYear()) * 12 +
      (dateFin.getMonth() - dateDebut.getMonth());
    const differenceInYears = Math.floor(differenceInMonths / 12);
    const remainingMonths = differenceInMonths % 12;
    const mois_val =
      remainingMonths + Number((differenceInDays / 30).toFixed(1));
    return {
      annee: Number.isNaN(differenceInYears)
        ? 0
        : Math.round(differenceInYears * 100) / 100,
      mois: Number.isNaN(mois_val) ? 0 : Math.round(mois_val * 100) / 100,
    };
  } catch (e) {
    console.error(
      "Erreur lors de la conversion des dates en experience. Erreur: ",
      e,
    );
    return { annee: 0, mois: 0 };
  }
}

export function calculeTotalExperience(annee, mois) {
  const totalMois = annee * 12 + mois;
  const totalAnnee = Math.floor(totalMois / 12);
  const totalMoisRestant = totalMois % 12;
  return { annee: totalAnnee, mois: totalMoisRestant };
}

const ExperienceProfessionnels = () => {
  const [currentExperience, setCurrentExperience] = useState({});
  const [educationFormDialogOpen, setEducationFormDialogOpen] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [experiences, setExperiences] = useState([]);
  const query = useQuery();
  const id_user = query.get("ref");
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const { Toast, showToast } = useToast();

  const confirmDelete = (experience) => {
    CVExperienceService.delete(experience).then((res) => {
      if (res && res.success) {
        showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
        handleFetchExperience();
      } else {
        showToast(TYPE_NOTIFICATION.ERROR, res.message);
      }
    });
  };

  const handleDeleteExperience = (experience) => {
    openConfirmDialog(
      "Confirmation",
      "Voullez vous supprimer cette ligne?",
      () => confirmDelete(experience),
    );
  };

  const handleCloseExperienceForm = () => {
    setEducationFormDialogOpen(false);
    setCurrentExperience({});
    handleFetchExperience();
  };

  const handleFetchExperience = () => {
    setFormLoading(true);
    CVExperienceService.liste({
      id_ext_user: id_user,
    })
      .then((res) => {
        if (res && res.data) {
          setExperiences(res.data);
        }
      })
      .finally(() => {
        setFormLoading(false);
      });
  };

  const handleCreateExperience = () => {
    setEducationFormDialogOpen(true);
    setCurrentExperience({});
  };
  const handleUpdateExperience = (experience) => {
    setEducationFormDialogOpen(true);
    setCurrentExperience(experience);
  };
  useEffect(() => {
    handleFetchExperience();
  }, []);
  return (
    <>
      <Toast />
      <ExperienceForm
        open={educationFormDialogOpen}
        onFormClose={handleCloseExperienceForm}
        idExperience={currentExperience.id_experience}
      />
      <DialogComponent />
      <Paper >
        <LinearProgress
          sx={{
            borderRadius: "3px 3px 0 0",
            display: formLoading ? "" : "none",
          }}
        />
        <Grid item xs={12} width={"100%"} >
          <CardHeader
            sx={{ m: 2 }}
            title="Experiences professionnelles"
            titleTypographyProps={{ fontWeight: "bold" }}
            action={
              <Grid>
                <AppButton
                  icon={<AddCircleOutlineOutlinedIcon />}
                  text={"Ajouter"}
                  variant={"outlined"}
                  onClick={handleCreateExperience}
                />
              </Grid>
            }
          />
          {experiences.length > 0 ? (
            experiences.map((item, index) => {
              const dateFin = item.date_fin_experience
                ? new Date(item.date_fin_experience)
                : new Date();
              const dateDebut = new Date(item.date_debut_experience);
              let experience = calculeExperience(
                item.date_debut_experience,
                item.date_fin_experience === "0000-00-00 00:00:00"
                  ? new Date()
                  : item.date_fin_experience,
              );
              return (
                <Grid key={index}>
                  <ul>
                    <CardHeader
                      title={`${item.experience_mission}`}
                      titleTypographyProps={{
                        color: "primary",
                        sx: {
                          fontSize: "20px",
                          fontWeight: "bold",
                          mb: 1,
                        },
                      }}
                      action={
                        <Grid mr={3}>
                          <Chip
                            sx={{
                              display:
                                item.date_fin_experience !== "0000-00-00"
                                  ? "none"
                                  : "block",
                            }}
                            label={`${item.date_fin_experience !== "0000-00-00" ? "" : "En poste"}`}
                            variant="outlined"
                            color="success"
                            size="small"
                          />
                        </Grid>
                      }
                      subheader={
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={6} lg={4}>
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                            >
                              <CalendarMonthOutlined />
                              <span>
                                <b>Periode :</b>
                                <br />
                                {` ${dateDebut.toLocaleDateString()} - ${item.date_fin_experience !== "0000-00-00" ? dateFin.toLocaleDateString() : "Actuel"} `}
                                <Chip
                                  sx={{
                                    mb: 0.5,
                                  }}
                                  size="small"
                                  variant="outlined"
                                  color="primary"
                                  label={`${experience.annee === 0 ? "" : experience.annee + " ans"}  ${experience.mois} mois`}
                                />
                              </span>
                            </Stack>
                          </Grid>
                          <Grid item xs={12} md={6} lg={4}>
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                            >
                              <BadgeOutlinedIcon />
                              <span>
                                <span>
                                  <b>Statut :</b> <br />
                                  {` ${item.statut || ""}`}
                                </span>
                              </span>
                            </Stack>
                          </Grid>
                          <Grid item xs={12} md={6} lg={4}>
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                            >
                              <BusinessIcon />
                              <span>
                                <span>
                                  <b>Etablissement :</b> <br />
                                  {` ${item.organisme_experience || ""}`}
                                </span>
                              </span>
                            </Stack>
                          </Grid>
                          <Grid item xs={12} md={6} lg={4}>
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                            >
                              <Science />
                              <span>
                                <span>
                                  <b>Domaine :</b> <br />
                                  {` ${item.domaine_experience || ""}`}
                                </span>
                              </span>
                            </Stack>
                          </Grid>
                          <Grid item xs={12} md={6} lg={4}>
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                            >
                              <ScienceOutlinedIcon />
                              <span>
                                <span>
                                  <b>Sous domaine d'expérience :</b> <br />
                                  {` ${item.sous_domaine_experience || ""}`}
                                </span>
                              </span>
                            </Stack>
                          </Grid>
                          <Grid item xs={12} md={6} lg={4}>
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                            >
                              <span>
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  spacing={1}
                                >
                                  <SupervisorAccountOutlinedIcon />
                                  <b>Reference :</b> <br />
                                </Stack>
                                <Grid container sx={{ fontSize: "15px" }}>
                                  <ul>
                                    <li>
                                      <b>Nom :</b> {` ${item.reference || ""}`}
                                    </li>
                                    <li>
                                      <b>Phone :</b>
                                      {` ${item.num_ref || ""}`}
                                    </li>
                                    <li>
                                      <b>Email : </b>
                                      {`${item.email_ref || ""}`}
                                    </li>
                                  </ul>
                                </Grid>
                              </span>
                            </Stack>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sx={{
                              borderLeft: "1px solid red",
                              boxShadow: "3px solid rgba(70, 65, 65, 0.5)",
                              shadowColor: "red",
                              shadowOffset: { width: 0, height: 2 },
                              shadowOpacity: 0.5,
                              shadowRadius: 2,
                              mt: 2,
                            }}
                          >
                            <Stack
                              direction="column"
                              alignItems="flex-start"
                              spacing={1}
                            >
                              <Stack
                                direction="row"
                                alignItems="flex-start"
                                spacing={1}
                              >
                                <DescriptionOutlinedIcon />
                                <span>
                                  <b>Description:</b>
                                </span>
                              </Stack>
                              <CardHeader
                                subheader={`${item.description_experience || ""}`}
                              />
                            </Stack>
                          </Grid>
                        </Grid>
                      }
                    />
                    <CardActions sx={{ justifyContent: "flex-end", mr: 2 }}>
                      <AppButton
                        icon={<EditOutlined />}
                        text={"Modifier"}
                        variant={"outlined"}
                        onClick={(e) => handleUpdateExperience(item)}
                      />
                      <AppButton
                        icon={<DeleteOutline />}
                        text={"Supprimer"}
                        onClick={(e) => handleDeleteExperience(item)}
                        color={"warning"}
                        variant={"outlined"}
                      />
                    </CardActions>
                  </ul>
                  <Divider variant="middle" />
                </Grid>
              );
            })
          ) : (
            <Grid item p={3}>
              <Alert variant="outlined" color="info" icon={<InfoOutlined />}>
                {" "}
                Aucune information
              </Alert>
            </Grid>
          )}
        </Grid>
      </Paper>
    </>
  );
};

export default ExperienceProfessionnels;
